<template>
    <b-form
        class="step-form text-center registered-customer-id"
        @submit.stop.prevent="onSubmit"
    >
        <div class="row">
            <div class="col-lg-12">
                <div class="fields-area registration-completed">
                    <div class="row">
                        <div class="col-lg-12">
                            <!-- <h3>Thank you</h3> -->
                            <p>
                                {{ registrationText }}
                            </p>

                            <div class="generated-customer-id">
                                <!-- <h4>{{ form.idenfoId }}</h4> -->
                                <h4>{{ idenfoID }}</h4>
                                <p>REFERENCE NUMBER</p>
                            </div>
                        </div>
                    </div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    class="btn-min-width"
                    :btn-label="registrationBtnText"
                ></base-button>
            </div>
        </div>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {}, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            registrationText: null,
            registrationBtnText: null,
            idenfoID: '',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['form', 'dataSegmentId']),

        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.onLoad()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.onLoad()
        this.idenfoID = this.$store.state.registration.form.idenfoId
        this.$store.commit('initDefaultFields', 'form')

        // let routerName = this.$route.name
        // window.onpopstate = function (event) {
        //     alert('location: ')
        //     if (routerName == 'public-registration-finish') {
        //         //  this.$router.push({
        //         //         name: 'public-registration-finish',
        //         //         params: {
        //         //             dataSegmentId: this.dataSegmentId,
        //         //         },
        //         //     })
        //     }
        // }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        onSubmit() {
            window.location.href = 'https://jsil.com/'
            // if (this.$route.meta.publicRegistration === true) {
            //     this.$router.push({
            //         name: 'public-registration-identity-upload',
            //         params: {
            //             dataSegmentId: this.dataSegmentId,
            //         },
            //     })
            // } else {
            //     this.$router.push('/register-customer/')
            // }
        }, // End of onSubmit() method

        /**
         * Handle when the page is loaded
         *
         * @return {void}
         */
        onLoad() {
            // if (!this.form.idenfoId) {
            //     return this.onSubmit()
            // }
            if (this.$route.meta.publicRegistration === true) {
                this.registrationText =
                    ' Congratulations! You have successfully submitted your Digital Account Opening Request with JS Investments Limited.\n Thank you for applying. You will receive an acknowledgment email within 3 working days upon verification. \n'
                this.registrationBtnText = 'GO TO MAIN WEBSITE'
            } else {
                this.registrationText =
                    ' Customer account creation is in process.'
                this.registrationBtnText = 'REGISTER ANOTHER CUSTOMER'
            }
        }, // End of onLoad() method
    }, // End of Component > watch
} // End of export default
</script>
